export default function getRankColor(rank) {
    const rank_color = ['#EAB308', '#8C8E90', '#FFD7B6'];
    if (rank <= rank_color.length) return rank_color[rank - 1]
    return '#6B7280'
}